import React, { useEffect } from "react";
import JSEncrypt from "jsencrypt";
const EncryptPassword = (passwordToEncrypt) => {
  const publicKeyString = process.env.REACT_APP_PUBLIC_KEY;
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKeyString);
  // Encrypt the password using the public key
  const encryptedPassword = encrypt.encrypt(passwordToEncrypt);
  // Print the encrypted password to the console
  console.log("Encrypted Password:", encryptedPassword);
  return encryptedPassword;
};

const EncryptMessage = (messageToEncrypt) => {
  const publicKeyString = process.env.REACT_APP_PUBLIC_KEY;
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKeyString);
  const encryptedMessage = encrypt.encrypt(messageToEncrypt);
  // Print the encrypted password to the console
  console.log("Encrypted Message:", encryptedMessage);
  return encryptedMessage;
};

export default EncryptPassword;
export {EncryptMessage};